import React, { memo } from "react";

const tones = {
  green: `
    bg-emerald-50 dark:bg-emerald-900/30
    text-emerald-700 dark:text-emerald-400
    border border-emerald-200/60 dark:border-emerald-800/30
  `,
  amber: `
    bg-amber-50 dark:bg-amber-900/30
    text-amber-700 dark:text-amber-400
    border border-amber-200/60 dark:border-amber-800/30
  `,
  orange: `
    bg-orange-50 dark:bg-orange-900/30
    text-orange-700 dark:text-orange-400
    border border-orange-200/60 dark:border-orange-800/30
  `,
  blue: `
    bg-blue-50 dark:bg-blue-900/30
    text-blue-700 dark:text-blue-400
    border border-blue-200/60 dark:border-blue-800/30
  `,
  indigo: `
    bg-indigo-50 dark:bg-indigo-900/30
    text-indigo-700 dark:text-indigo-400
    border border-indigo-200/60 dark:border-indigo-800/30
  `,
  violet: `
    bg-violet-50 dark:bg-violet-900/30
    text-violet-700 dark:text-violet-400
    border border-violet-200/60 dark:border-violet-800/30
  `,
  pink: `
    bg-pink-50 dark:bg-pink-900/30
    text-pink-700 dark:text-pink-400
    border border-pink-200/60 dark:border-pink-800/30
  `,
  teal: `
    bg-teal-50 dark:bg-teal-900/30
    text-teal-700 dark:text-teal-400
    border border-teal-200/60 dark:border-teal-800/30
  `,
  slate: `
    bg-slate-50 dark:bg-slate-800
    text-slate-600 dark:text-slate-300
    border border-slate-200/60 dark:border-slate-700/60
  `,
  red: `
    bg-red-50 dark:bg-red-900/30
    text-red-700 dark:text-red-400
    border border-red-200/60 dark:border-red-800/30
  `,
};

const Badge = memo(function Badge({
  tone = "slate",
  children,
  className = "",
}) {
  return (
    <span
      className={`
        inline-flex items-center justify-center
        rounded-full
        px-2.5 py-0.5
        text-[10px]
        font-semibold
        tracking-wide
        whitespace-nowrap
        ${tones[tone]}
        ${className}
      `}
    >
      {children}
    </span>
  );
});

export default Badge;